import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  matCheckBox,
  matFunctions,
  matListAlt,
  matStar,
  matTextSnippet,
} from '@ng-icons/material-icons/baseline';
import { matInputOutline } from '@ng-icons/material-icons/outline';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FieldType } from '@shared/components/dynamic-form/models/field';

@Component({
  selector: 'app-field-type-drag-placeholder',
  imports: [NgIcon, CommonModule, DragDropModule, TranslateModule],
  viewProviders: [
    provideIcons({
      matCheckBox,
      matFunctions,
      matInputOutline,
      matListAlt,
      matStar,
      matTextSnippet,
    }),
  ],
  templateUrl: './field-type-drag-placeholder.component.html',
})
export class FieldTypeDragPlaceholderComponent {
  fieldType = input.required<FieldType>();
}
